<template>
  <svg
    width="150"
    height="130"
    viewBox="0 0 150 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.1079 19.5718C29.0083 19.5718 34.6106 24.9185 34.6106 31.5042C34.6106 38.0899 29.0083 43.4366 22.1079 43.4366C15.2074 43.4366 9.60515 38.0899 9.60515 31.5042C9.60515 24.9185 15.2074 19.5718 22.1079 19.5718ZM73.3207 105.86C64.3858 102.766 54.5524 103.03 45.814 106.599C41.8435 108.224 37.4709 109.124 32.8798 109.124C14.7329 109.124 0 95.0635 0 77.7445C0 65.1719 9.61767 54.3164 21.8316 49.3105C30.326 45.8351 37.1736 39.4842 41.0566 31.48C50.1098 12.8528 69.8579 0 92.83 0C124.383 0 150 24.4485 150 54.5622C150 84.6759 124.383 109.124 92.83 109.124C85.98 109.124 79.4098 107.972 73.3207 105.86Z"
      fill="#FFF5F1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M99.2945 77.4755L77.3692 93.9553L32.1552 102.434L8.83569 77.8152L31.2548 51.8791H77.0925L99.2945 77.4755Z"
      fill="#0E2931"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M86.7378 79.3203L77.5261 100.103C77.001 101.287 75.6174 101.821 74.4359 101.294L41.8412 86.7685C40.6597 86.242 40.1276 84.8547 40.6527 83.67L62.2187 35.0155C62.7438 33.8308 64.1273 33.2972 65.3089 33.8238L97.9035 48.3496C99.0851 48.8762 99.6172 50.2635 99.092 51.4482L95.5386 59.465L97.6687 62.1354L90.142 79.1162L86.7378 79.3203Z"
      fill="white"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M94.876 52.9968L93.5501 55.9881L62.848 42.3057L64.1739 39.3144L94.876 52.9968Z"
      fill="#F8D2C4"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M93.7329 59.184L89.824 68.0028L56.1744 53.0068L60.0833 44.188L93.7329 59.184Z"
      fill="#A8A5A5"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M88.6712 70.6035L88.0304 72.0494L54.3809 57.0535L55.0217 55.6076L88.6712 70.6035Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M87.3153 73.6626L86.6744 75.1085L53.0248 60.1125L53.6657 58.6666L87.3153 73.6626Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M85.9593 76.7217L85.3185 78.1676L51.6689 63.1716L52.3098 61.7258L85.9593 76.7217Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.6034 79.7808L83.9625 81.2267L50.313 66.2308L50.9539 64.7849L84.6034 79.7808Z"
      fill="#B9D7F7"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M83.2475 82.8399L82.6066 84.2858L48.9571 69.2899L49.598 67.844L83.2475 82.8399Z"
      fill="#B9D7F7"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M81.8916 85.899L81.2507 87.3449L47.6011 72.349L48.242 70.9031L81.8916 85.899Z"
      fill="#B9D7F7"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M80.5356 88.9581L79.8948 90.404L46.2452 75.408L46.8861 73.9621L80.5356 88.9581Z"
      fill="#B9D7F7"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M79.1796 92.0172L78.5387 93.463L44.8892 78.4671L45.5301 77.0212L79.1796 92.0172Z"
      fill="#B9D7F7"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M77.8237 95.0762L77.1828 96.5221L43.5333 81.5262L44.1742 80.0803L77.8237 95.0762Z"
      fill="#B9D7F7"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M73.5546 61.4105L79.0661 83.4714C79.3803 84.729 78.6182 86.0039 77.364 86.3189L42.7642 95.0098C41.51 95.3249 40.2385 94.5608 39.9243 93.3032L27.0212 41.6556C26.707 40.3979 27.4691 39.123 28.7233 38.808L63.3231 30.1171C64.5773 29.802 65.8488 30.5661 66.163 31.8237L68.289 40.3337L71.6075 41.1216L76.1108 59.1471L73.5546 61.4105Z"
      fill="white"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M63.7933 35.6479L64.5866 38.8232L31.9957 47.0095L31.2025 43.8342L63.7933 35.6479Z"
      fill="#F8D2C4"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M66.6939 41.2278L69.0327 50.5891L33.3131 59.5613L30.9744 50.2L66.6939 41.2278Z"
      fill="#A8A5A5"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M69.7224 53.3498L70.1059 54.8846L34.3863 63.8569L34.0028 62.322L69.7224 53.3498Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M70.5337 56.5971L70.9171 58.1319L35.1975 67.1041L34.8141 65.5693L70.5337 56.5971Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M71.3449 59.8444L71.7283 61.3792L36.0088 70.3514L35.6253 68.8166L71.3449 59.8444Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M72.1562 63.0916L72.5396 64.6265L36.82 73.5987L36.4366 72.0638L72.1562 63.0916Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M72.9674 66.339L73.3509 67.8738L37.6313 76.846L37.2479 75.3111L72.9674 66.339Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M73.7787 69.5862L74.1622 71.1211L38.4425 80.0933L38.0591 78.5584L73.7787 69.5862Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M74.59 72.8335L74.9734 74.3683L39.2538 83.3405L38.8704 81.8057L74.59 72.8335Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M75.4013 76.0808L75.7847 77.6157L40.0651 86.5878L39.6816 85.053L75.4013 76.0808Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M76.2126 79.3281L76.596 80.8629L40.8764 89.8351L40.493 88.3003L76.2126 79.3281Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M59.0648 60.4793L71.2016 79.6918C71.8934 80.7871 71.5689 82.2373 70.4766 82.9311L40.344 102.069C39.2517 102.763 37.8054 102.438 37.1135 101.342L8.69949 56.3632C8.00762 55.2679 8.33221 53.8177 9.42449 53.1239L39.5571 33.9856C40.6493 33.2918 42.0957 33.6173 42.7875 34.7125L47.4693 42.1238L50.8667 41.8277L60.7835 57.5259L59.0648 60.4793Z"
      fill="white"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.7342 39.0891L43.4811 41.8544L15.0981 59.8815L13.3513 57.1162L41.7342 39.0891Z"
      fill="#F8D2C4"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46.2346 43.4745L51.3848 51.6272L20.277 71.3849L15.1269 63.2323L46.2346 43.4745Z"
      fill="#A8A5A5"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.9036 54.071L53.748 55.4076L22.6402 75.1654L21.7958 73.8287L52.9036 54.071Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.69 56.899L55.5344 58.2357L24.4267 77.9934L23.5823 76.6567L54.69 56.899Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.4766 59.727L57.321 61.0637L26.2132 80.8214L25.3688 79.4848L56.4766 59.727Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.263 62.555L59.1074 63.8917L27.9997 83.6494L27.1553 82.3127L58.263 62.555Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.0496 65.383L60.894 66.7197L29.7862 86.4774L28.9418 85.1407L60.0496 65.383Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.836 68.2111L62.6804 69.5477L31.5727 89.3055L30.7283 87.9688L61.836 68.2111Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M63.6226 71.039L64.467 72.3757L33.3592 92.1335L32.5148 90.7968L63.6226 71.039Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M65.409 73.8276L66.2534 75.1643L35.1457 94.922L34.3013 93.5853L65.409 73.8276Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M67.1956 76.6556L68.04 77.9922L36.9322 97.75L36.0878 96.4133L67.1956 76.6556Z"
      fill="#D2D2D2"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M75.493 79.6627C75.493 78.6578 75.8957 77.6941 76.6125 76.9835C77.3293 76.2729 78.3014 75.8737 79.3151 75.8737C83.9167 75.8737 91.5984 75.8737 96.2 75.8737C98.3109 75.8737 100.022 77.5701 100.022 79.6627C100.022 89.3169 100.022 114.757 100.022 124.412C100.022 126.504 98.3109 128.2 96.2 128.2C81.3257 128.2 27.3939 128.2 12.5197 128.2C10.4088 128.2 8.69757 126.504 8.69757 124.412C8.69757 114.757 8.69757 89.3169 8.69757 79.6627C8.69757 77.5701 10.4088 75.8737 12.5197 75.8737C17.1212 75.8737 24.803 75.8737 29.4046 75.8737C30.4182 75.8737 31.3904 76.2729 32.1072 76.9835C32.824 77.6941 33.2266 78.6578 33.2266 79.6627C33.2266 81.2845 33.2266 83.1744 33.2266 84.7963C33.2266 85.8011 33.6293 86.7649 34.3461 87.4754C35.0629 88.186 36.0351 88.5852 37.0488 88.5852C45.0821 88.5852 63.6376 88.5852 71.6709 88.5852C72.6846 88.5852 73.6567 88.186 74.3735 87.4754C75.0903 86.7649 75.493 85.8011 75.493 84.7963C75.493 83.1744 75.493 81.2845 75.493 79.6627Z"
      fill="#153D49"
    />
    <mask
      id="mask0_17941_75463"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="8"
      y="75"
      width="93"
      height="54"
    >
      <path
        d="M75.388 79.7153C75.388 78.695 75.7922 77.7164 76.5118 76.9949C77.2313 76.2734 78.2072 75.8681 79.2248 75.8681C83.844 75.8681 91.5553 75.8681 96.1746 75.8681C98.2936 75.8681 100.011 77.5906 100.011 79.7153C100.011 89.5181 100.011 115.35 100.011 125.153C100.011 127.278 98.2936 129 96.1746 129C81.2431 129 27.104 129 12.1726 129C10.0536 129 8.33582 127.278 8.33582 125.153C8.33582 115.35 8.33582 89.5181 8.33582 79.7153C8.33582 77.5906 10.0536 75.8681 12.1726 75.8681C16.7918 75.8681 24.5031 75.8681 29.1224 75.8681C30.14 75.8681 31.1159 76.2734 31.8354 76.9949C32.5549 77.7164 32.9592 78.695 32.9592 79.7153C32.9592 81.3621 32.9592 83.2811 32.9592 84.9279C32.9592 85.9483 33.3634 86.9268 34.083 87.6483C34.8025 88.3698 35.7784 88.7751 36.796 88.7751C44.8602 88.7751 63.487 88.7751 71.5512 88.7751C72.5688 88.7751 73.5447 88.3698 74.2642 87.6483C74.9838 86.9268 75.388 85.9483 75.388 84.9279C75.388 83.2811 75.388 81.3621 75.388 79.7153Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_17941_75463)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.3166 68.3078C93.8394 71.559 93.5776 82.9261 94.0515 109.466C94.4096 129.518 8.3358 118.849 8.3358 118.849C8.3358 118.849 8.25728 132.055 8.92414 132.614C19.752 141.699 103.818 154.481 113.578 123.462C116.726 113.457 113.169 96.5167 112.688 94.227"
        fill="#0E2931"
      />
    </g>
    <path
      d="M75.388 79.7153C75.388 78.695 75.7922 77.7164 76.5118 76.9949C77.2313 76.2734 78.2072 75.8681 79.2248 75.8681C83.844 75.8681 91.5553 75.8681 96.1746 75.8681C98.2936 75.8681 100.011 77.5906 100.011 79.7153C100.011 89.5181 100.011 115.35 100.011 125.153C100.011 127.278 98.2936 129 96.1746 129C81.2431 129 27.104 129 12.1726 129C10.0536 129 8.33582 127.278 8.33582 125.153C8.33582 115.35 8.33582 89.5181 8.33582 79.7153C8.33582 77.5906 10.0536 75.8681 12.1726 75.8681C16.7918 75.8681 24.5031 75.8681 29.1224 75.8681C30.14 75.8681 31.1159 76.2734 31.8354 76.9949C32.5549 77.7164 32.9592 78.695 32.9592 79.7153C32.9592 81.3621 32.9592 83.2811 32.9592 84.9279C32.9592 85.9483 33.3634 86.9268 34.083 87.6483C34.8025 88.3698 35.7784 88.7751 36.796 88.7751C44.8602 88.7751 63.487 88.7751 71.5512 88.7751C72.5688 88.7751 73.5447 88.3698 74.2642 87.6483C74.9838 86.9268 75.388 85.9483 75.388 84.9279C75.388 83.2811 75.388 81.3621 75.388 79.7153Z"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M69.3826 102.434C70.9577 102.434 72.2345 103.714 72.2345 105.294C72.2345 106.873 70.9577 108.153 69.3826 108.153C62.6286 108.153 45.7185 108.153 38.9645 108.153C37.3894 108.153 36.1125 106.873 36.1125 105.294C36.1125 103.714 37.3894 102.434 38.9645 102.434C45.7185 102.434 62.6286 102.434 69.3826 102.434Z"
      fill="#0E2931"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.1303 89.2608C83.9183 88.2755 84.1622 87.2468 84.7937 86.4625C85.4252 85.6781 86.3766 85.2222 87.3819 85.2222C97.8185 85.2222 125.205 85.2222 135.642 85.2222C136.647 85.2222 137.599 85.6781 138.23 86.4625C138.861 87.2468 139.105 88.2755 138.893 89.2608C136.562 100.097 130.345 129 130.345 129H92.6783C92.6783 129 86.4612 100.097 84.1303 89.2608Z"
      fill="#4F1F17"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M130.05 64.4268V111.713H89.5783V64.4268H130.05Z"
      fill="#D3D3D3"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M133.445 68.1739V115.46H92.9734V68.1739H133.445Z"
      fill="white"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M133.445 68.1739V115.46H92.9734V68.1739H133.445Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M122.105 73.7465V77.2367H104.314V73.7465H122.105Z"
      fill="#A8A5A5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M130.05 80.5039V81.9552H95.418V80.5039H130.05Z"
      fill="#D2D2D2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M130.05 86.6186V88.0699H95.418V86.6186H130.05Z"
      fill="#D2D2D2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M130.05 92.7333V94.1846H95.418V92.7333H130.05Z"
      fill="#D2D2D2"
    />
    <path
      d="M133.445 68.1739V115.46H92.9734V68.1739H133.445Z"
      stroke="#153D49"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M81.2608 93.2179C81.1214 92.5191 81.3019 91.7944 81.7525 91.2433C82.2031 90.6921 82.8764 90.3726 83.5871 90.3726C89.7018 90.3726 103.379 90.3726 103.379 90.3726L111.512 98.0981C111.512 98.0981 131.517 98.0981 139.292 98.0981C140.022 98.0981 140.712 98.4356 141.162 99.0129C141.611 99.5903 141.77 100.343 141.593 101.054C140.016 107.38 136.353 122.074 135.075 127.198C134.811 128.257 133.862 129 132.773 129C125.366 129 97.9142 129 90.3428 129C89.212 129 88.2383 128.2 88.0165 127.088C86.7612 120.794 82.7537 100.702 81.2608 93.2179Z"
      fill="#FF6347"
    />
    <mask
      id="mask1_17941_75463"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="81"
      y="90"
      width="61"
      height="39"
    >
      <path
        d="M81.2608 93.2179C81.1214 92.5191 81.3019 91.7944 81.7525 91.2433C82.2031 90.6921 82.8764 90.3726 83.5871 90.3726C89.7018 90.3726 103.379 90.3726 103.379 90.3726L111.512 98.0981C111.512 98.0981 131.517 98.0981 139.292 98.0981C140.022 98.0981 140.712 98.4356 141.162 99.0129C141.611 99.5903 141.77 100.343 141.593 101.054C140.016 107.38 136.353 122.074 135.075 127.198C134.811 128.257 133.862 129 132.773 129C125.366 129 97.9142 129 90.3428 129C89.212 129 88.2383 128.2 88.0165 127.088C86.7612 120.794 82.7537 100.702 81.2608 93.2179Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_17941_75463)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M136.216 94.3484C135.811 98.691 135.663 117.615 123.716 123.532C113.343 128.669 97.5719 127.062 87.2709 128.028C87.5695 128.37 90.6536 137.288 114.362 137.89C136.615 138.455 144.947 131.643 149.604 119.244C156.961 99.6587 145.271 96.36 143.233 94.9818"
        fill="#B54D3A"
      />
    </g>
    <path
      d="M81.2608 93.2179C81.1214 92.5191 81.3019 91.7944 81.7525 91.2433C82.2031 90.6921 82.8764 90.3726 83.5871 90.3726C89.7018 90.3726 103.379 90.3726 103.379 90.3726L111.512 98.0981C111.512 98.0981 131.517 98.0981 139.292 98.0981C140.022 98.0981 140.712 98.4356 141.162 99.0129C141.611 99.5903 141.77 100.343 141.593 101.054C140.016 107.38 136.353 122.074 135.075 127.198C134.811 128.257 133.862 129 132.773 129C125.366 129 97.9142 129 90.3428 129C89.212 129 88.2383 128.2 88.0165 127.088C86.7612 120.794 82.7537 100.702 81.2608 93.2179Z"
      stroke="#000560"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
